/* global axios */
import ApiClient from './ApiClient';

class DealAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  // Listar deals com filtros
  get(params = {}) {
    const queryParams = new URLSearchParams();

    const {
      page = 1,
      sort = '-created_at',
      status,
      stage,
      owner_id,
      company_id,
      contact_id,
      conversation_id,
      funnel_id,
      closing_from,
      closing_to,
    } = params;

    queryParams.append('page', page);
    if (sort) queryParams.append('sort', sort);
    if (status) queryParams.append('status', status);
    if (stage) queryParams.append('stage', stage);
    if (owner_id) queryParams.append('owner_id', owner_id);
    if (company_id) queryParams.append('company_id', company_id);
    if (contact_id) queryParams.append('contact_id', contact_id);
    if (conversation_id) queryParams.append('conversation_id', conversation_id);
    if (funnel_id) queryParams.append('funnel_id', funnel_id);
    if (closing_from) queryParams.append('closing_from', closing_from);
    if (closing_to) queryParams.append('closing_to', closing_to);

    return axios.get(`${this.url}?${queryParams.toString()}`);
  }

  // Buscar deal específico
  getDeal(id) {
    return axios.get(`${this.url}/${id}`);
  }

  // Criar deal
  create(dealData) {
    return axios.post(this.url, { deal: dealData });
  }

  // Atualizar deal
  update(id, dealData) {
    return axios.patch(`${this.url}/${id}`, { deal: dealData });
  }

  // Deletar deal
  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Buscar por nome/descrição
  search(query, page = 1) {
    return axios.get(`${this.url}/search`, {
      params: { q: query, page },
    });
  }

  // Estatísticas
  getStats(period = '30d') {
    return axios.get(`${this.url}/stats`, {
      params: { period },
    });
  }

  // Marcar como ganho
  markWon(id) {
    return axios.post(`${this.url}/${id}/mark_won`);
  }

  // Marcar como perdido
  markLost(id, lossReason = null, lossNotes = null) {
    return axios.post(`${this.url}/${id}/mark_lost`, {
      loss_reason: lossReason,
      loss_notes: lossNotes,
    });
  }

  // Reabrir deal
  reopen(id) {
    return axios.post(`${this.url}/${id}/reopen`);
  }

  // Mover para outro estágio
  moveStage(id, stageName, probability = null) {
    return axios.post(`${this.url}/${id}/move_stage`, {
      stage_name: stageName,
      probability,
    });
  }

  // Contatos do deal
  getContacts(id, page = 1) {
    return axios.get(`${this.url}/${id}/contacts`, { params: { page } });
  }

  // Atividades do deal
  getActivities(id, page = 1) {
    return axios.get(`${this.url}/${id}/activities`, { params: { page } });
  }

  // Notas do deal
  getNotes(id, page = 1) {
    return axios.get(`${this.url}/${id}/notes`, { params: { page } });
  }

  // Criar nota no deal
  createNote(id, { title, content }) {
    return axios.post(`${this.url}/${id}/notes`, { title, content });
  }

  // Kanban view - deals agrupados por estágio do funnel
  getKanban(funnelId) {
    return axios.get(`${this.url}/kanban`, {
      params: { funnel_id: funnelId },
    });
  }

  // Deals agrupados por estágio
  getGrouped(funnelId) {
    return axios.get(`${this.url}/grouped`, {
      params: { funnel_id: funnelId },
    });
  }

  // Bulk Actions

  // Bulk move deals to a new stage
  bulkMoveStage(dealIds, stageName, probability = null) {
    return axios.post(`${this.url}/bulk_move`, {
      deal_ids: dealIds,
      stage_name: stageName,
      probability,
    });
  }

  // Bulk assign deals to an agent
  bulkAssign(dealIds, ownerId) {
    return axios.post(`${this.url}/bulk_assign`, {
      deal_ids: dealIds,
      owner_id: ownerId,
    });
  }

  // Bulk mark deals as won
  bulkMarkWon(dealIds) {
    return axios.post(`${this.url}/bulk_mark_won`, {
      deal_ids: dealIds,
    });
  }

  // Bulk mark deals as lost
  bulkMarkLost(dealIds, lossReason = null, lossNotes = null) {
    return axios.post(`${this.url}/bulk_mark_lost`, {
      deal_ids: dealIds,
      loss_reason: lossReason,
      loss_notes: lossNotes,
    });
  }
}

export default new DealAPI();
